import { IAppState } from '../common/state';
import { EDealType } from '../types/dealType';
import { dealTypeFromJsonQuery } from '../utils/category';

export const getDealType = ({ filters: { jsonQuery } }: IAppState): EDealType => {
  return dealTypeFromJsonQuery(jsonQuery);
};
